import apis from "../../api/index";
import {dateUtils} from "../../utils/dateUtils";
import {utils} from "../../utils/utils";
import md5 from 'js-md5';

export default {
    name: "UserManage",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                callback();
            }
        };
        return {
            formLabelWidth:'120px',
            rules: {
                UserName: [
                  { required: true, message: '请填写登录用户名', trigger: 'change' }
                ],
                Tel: [
                  { required: true, message: '请填写电话号码', trigger: 'change' },
                  { max: 250, message: '处理意见不能超过250个字符', trigger: 'change' }
                ],
                Password:[
                    { validator: validatePass, trigger: 'change' }
                ],
            },

            query: {
                isWorker:"",
                isOcr:"",
                userName: "",
                roleId:"",
                registerTimes: '',
                pageIndex: 1,
                pageSize: 10
            },

            tableCols:[
                {
                    "prop": "UserID",
                    "label": "用户编号",
                    "width": "140",
                    "align": "center"
                },
                {
                    "prop": "WxNickName",
                    "label": "微信昵称",
                    "align": "center"
                },
                {
                    "prop": "UserName",
                    "label": "用户名称",
                    "align": "center"
                },
                {
                    "prop": "Tel",
                    "label": "电话号码",
                    "width": "160",
                    "align": "center"
                },
                {
                    "prop": "HeadImg",
                    "label": "头像",
                    "width": "140",
                    "align": "center"
                },
                {
                    "prop": "CreateTime",
                    "label": "注册时间",
                    "width": "180",
                    "align": "center"
                },
                {
                    "prop": "IsWorker",
                    "label": "是否工作人员",
                    "width": "160",
                    "align": "center"
                },
                {
                    "prop": "IsOcr",
                    "label": "是否身份认证",
                    "width": "160",
                    "align": "center"
                },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "300",
                    "align": "center"
                }
            ],
            workerTypes:[
                {
                    value:0,
                    label:"普通用户"
                },
                {
                    value:1,
                    label:"工作人员"
                }
            ],
            ocrTypes:[
                {
                    value:0,
                    label:"否"
                },
                {
                    value:1,
                    label:"是"
                }
            ],
            tableData: [],
            pageTotal: 0,
            scrollHeight:250,
            returnItem: null,
            returnItemOAut:null,
            editVisible: false,
            oautVisible:false,
            props: {
                label: 'RoleName',
                id: 'RoleID'
            },
            roleTreeData:[],
            checkedRoles:[],
        };
    },
    created() {
        this.getRoleData();
        this.getData();
    },
    methods: {
        getData() {
            let that = this;
            let queryPara = utils.deepCopy(that.query);
            if(queryPara.registerTimes && JSON.stringify(queryPara.registerTimes) !== '{}'){
                queryPara.registerTimes = dateUtils.dateToStr("yyyy-MM-dd 00:00:00",queryPara.registerTimes[0])+","+dateUtils.dateToStr("yyyy-MM-dd 23:59:59",queryPara.registerTimes[1]);
            }else{
                queryPara.registerTimes = "";
            }
            apis.getUserByCondition(queryPara).then(res => {
                that.tableData = res.resultData;
                that.pageTotal = res.totalCount || 0;
            });
        },
        getRoleData(callBack) {
            let that = this;
            let queryPara ={
                roleName:'',
                pageIndex: 1,
                pageSize: 10000
            }
            apis.getRolesByCondition(queryPara).then(res => {
                that.roleTreeData = res.resultData;
                if(callBack){
                    callBack(that.roleTreeData) 
                }
            });
        },
        getWorkerTypeName(value){
            let that = this;
            let name = "";
            for(let i=0;i<that.workerTypes.length;i++){
                if(that.workerTypes[i]["value"]+'' === value+''){
                    name = that.workerTypes[i]["label"];
                    break;
                }
            }
            return name;
        },
        getOcrTypeName(value){
            let that = this;
            let name = "";
            for(let i=0;i<that.ocrTypes.length;i++){
                if(that.ocrTypes[i]["value"]+'' === value+''){
                    name = that.ocrTypes[i]["label"];
                    break;
                }
            }
            return name;
        },
        
        // 触发搜索按钮
        refreshList() {
            this.query.pageIndex = 1;
            this.getData();
        },
        // 编辑操作
        handleEdit(index, row) {
            let that = this;
            if(row){
                that.editVisible = true;
                that.returnItem = utils.deepCopy(row);
            }
        },
        // 删除操作
        handleDelete(index, row) {
            let that = this;
            if(row){
                this.$confirm('确定取消吗?取消后需要用户重新上传照片, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let userId = row.UserID;
                    let obj = {
                        userId:userId
                    }
                    apis.deleteUser(obj).then(res => {
                        //0成功
                        //-1失败
                        //-2用户不存在
                        if(res === 0){
                            this.$message.success("修改成功");
                            that.getData();
                        }else if(res === -1){
                            this.$message.error("修改失败，请重试。");
                        }else if(res === -2){
                            this.$message.error("用户不存在，请重试。");
                        }
                    });
                }).catch(() => {
                    this.$message({
                      type: 'info',
                      message: '已取消删除'
                    });
                });
            }
        },
        // 授权操作
        handleOAuto(index, row) {
            let that = this;
            if(row){
              if(row.UserName){
                that.oautVisible = true;
                that.returnItemOAut = utils.deepCopy(row);
                that.checkedRoles = []
                that.getRoleData(function(){
                    if(that.returnItemOAut.RoleIds){
                        that.$refs.roleTree.setCheckedNodes([])
                        that.checkedRoles = that.returnItemOAut.RoleIds.split(',')
                    }
                    apis.getRoleLimitUsers().then(res => {
                        let limitObjs = res
                        for(let key in limitObjs){
                            if(limitObjs[key]){
                                if(limitObjs[key]['UserID']!==that.returnItemOAut.UserID){
                                    // var fruits = ["Banana", "Orange", "Apple", "Mango"];
                                    // var a = fruits.indexOf("Apple"); // 2
                                    for(let v=0;v<that.roleTreeData.length;v++){
                                        let menus = that.roleTreeData[v]['MenuIds'].split(',')
                                        let index = menus.indexOf(key+'')
                                        if(index>-1){
                                            that.roleTreeData[v]['disabled'] = true
                                        }
                                    }
                                }
                            }
                        }
                    });
                })
              }else{
                this.$message.error("先通过‘修改’功能设置用户登录名和密码后才能进行授权");
              }
            }
        },
        // 清空条件
        onClearCondtionChange(){
            this.query.userName = ""
            this.query.registerTimes = ""
            this.query.roleId=""
            this.query.isOcr=""
        },
        // 保存用户信息
        saveUserChange() {
            let that = this;
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    let obj = {
                        UserID :that.returnItem.UserID,
                        IsWorker:that.returnItem.IsWorker,
                        UserName:that.returnItem.UserName,
                        Tel:that.returnItem.Tel,
                        Password:that.returnItem.Password,
                        FddCode:that.returnItem.FddCode
                    };
                    if(!obj.Password){
                        delete obj.Password
                    }else{
                        if(obj.Password.length!==32){
                            obj.Password = md5(obj.Password)
                        }
                    }
                    apis.updateUser(obj).then(res => {
                        //-1失败
                        //-2用户不存在
                        //-3用户名已经存在
                        //1成功
                        if(res===1){
                            that.editVisible = false;
                            that.$message.success("修改用户信息成功");
                            that.getData();
                        }else if(res===-2){
                            this.$message.error("用户不存在。");
                        }else if(res===-3){
                            this.$message.error("用户名已经存在，不能重名。");
                        }else{
                            this.$message.error("修改用户信息失败");
                        }
                    });
                } else {
                  return false;
                }
            });
        },
        // 保存用户授权
        saveOAutChange(){
            let that = this
            if(that.returnItemOAut){
                let checkedNodes = this.$refs.roleTree.getCheckedNodes(false, true)
                let checkedRoleArray = []
                for(let i=0, len=checkedNodes.length; i<len; i++) {
                    checkedRoleArray.push(checkedNodes[i].RoleID)
                }
                let obj = {
                    IsWorker:1,
                    UserID:that.returnItemOAut.UserID,
                    UserName:that.returnItemOAut.UserName,
                    RoleIds:checkedRoleArray.length===0?'': checkedRoleArray.join(',')
                }
                apis.updateUser(obj).then(res => {
                    //-1失败
                    //-2用户不存在
                    //-3用户名已经存在
                    //1成功
                    if(res===1){
                        that.oautVisible = false;
                        that.$message.success("用户授权成功");
                        that.getData();
                    }else if(res===-2){
                        this.$message.error("用户不存在。");
                    }else{
                        this.$message.error("用户授权失败");
                    }
                });
            }
        },
        // 分页导航
        handlePageChange(val) {
            this.query.pageIndex = val;
            this.getData();
        },
        handleSizeChange(val){
            this.query.pageIndex = 1;
            this.query.pageSize = val;
            this.getData();
        },
        calcTableHeight(){
          this.$nextTick(() => {
            let height = $(".content-box .content").height() - $(".content-box .content .seach-container").height() - 16 - 24 -72;
            this.scrollHeight = (height);
          });
        }
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    watch: {

    },
    activated: function () {
    },

    deactivated: function () {

    },
  };
